<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.0001 18.3999C9.75008 18.3999 9.50008 18.3416 9.29175 18.2249C7.73341 17.3749 4.99175 16.4749 3.27508 16.2499L3.03341 16.2166C1.94175 16.0833 1.04175 15.0583 1.04175 13.9499V3.88326C1.04175 3.22492 1.30008 2.62493 1.77508 2.19159C2.25008 1.75826 2.86675 1.54993 3.51675 1.60826C5.35008 1.74993 8.11675 2.66659 9.68342 3.64993L9.88341 3.76659C9.94175 3.79993 10.0667 3.79993 10.1167 3.77493L10.2501 3.69159C11.8167 2.70826 14.5834 1.77493 16.4251 1.61659C16.4417 1.61659 16.5084 1.61659 16.5251 1.61659C17.1334 1.55826 17.7584 1.77493 18.2251 2.20826C18.7001 2.64159 18.9584 3.24159 18.9584 3.89992V13.9583C18.9584 15.0749 18.0584 16.0916 16.9584 16.2249L16.6834 16.2583C14.9667 16.4833 12.2167 17.3916 10.6917 18.2333C10.4917 18.3499 10.2501 18.3999 10.0001 18.3999ZM3.31675 2.84993C3.05008 2.84993 2.80841 2.94159 2.61675 3.11659C2.40841 3.30826 2.29175 3.58326 2.29175 3.88326V13.9499C2.29175 14.4416 2.71675 14.9166 3.19175 14.9833L3.44175 15.0166C5.31675 15.2666 8.19175 16.2083 9.85842 17.1166C9.93342 17.1499 10.0417 17.1583 10.0834 17.1416C11.7501 16.2166 14.6417 15.2666 16.5251 15.0166L16.8084 14.9833C17.2834 14.9249 17.7084 14.4416 17.7084 13.9499V3.89159C17.7084 3.58326 17.5917 3.31659 17.3834 3.11659C17.1667 2.92493 16.8917 2.83326 16.5834 2.84993C16.5667 2.84993 16.5001 2.84993 16.4834 2.84993C14.8917 2.99159 12.3251 3.84993 10.9251 4.72493L10.7917 4.81659C10.3334 5.09993 9.68342 5.09993 9.24175 4.82493L9.04175 4.70826C7.61675 3.83326 5.05008 2.98326 3.41675 2.84993C3.38341 2.84993 3.35008 2.84993 3.31675 2.84993Z"
      fill="#667085"
    />
    <path
      d="M10 17.7002C9.65833 17.7002 9.375 17.4169 9.375 17.0752V4.5752C9.375 4.23353 9.65833 3.9502 10 3.9502C10.3417 3.9502 10.625 4.23353 10.625 4.5752V17.0752C10.625 17.4252 10.3417 17.7002 10 17.7002Z"
      fill="#667085"
    />
    <path
      d="M6.45825 7.7002H4.58325C4.24159 7.7002 3.95825 7.41686 3.95825 7.0752C3.95825 6.73353 4.24159 6.4502 4.58325 6.4502H6.45825C6.79992 6.4502 7.08325 6.73353 7.08325 7.0752C7.08325 7.41686 6.79992 7.7002 6.45825 7.7002Z"
      fill="#667085"
    />
    <path
      d="M7.08325 10.2002H4.58325C4.24159 10.2002 3.95825 9.91686 3.95825 9.5752C3.95825 9.23353 4.24159 8.9502 4.58325 8.9502H7.08325C7.42492 8.9502 7.70825 9.23353 7.70825 9.5752C7.70825 9.91686 7.42492 10.2002 7.08325 10.2002Z"
      fill="#667085"
    />
  </svg>
</template>

<script>
export default {
  name: "BookIcon",

  data() {
    return {};
  },
  computed: {},
};
</script>